import PropTypes from 'prop-types';

const ChevronIcon = ({
    fill = '#656565',
    width,
    height,
    direction = 'down',
    ...props
}) => {
    const DIRECTION = { down: 0, right: 270, left: 90, up: 180 };
    return (
        <svg
            width={`${width}` || '15'}
            height={`${height}` || '9'}
            viewBox="0 0 15 9"
            transform={`rotate(${DIRECTION[direction]})`}
            {...props}
        >
            <path
                d="M7.01769 1.04098L0.199702 7.70766C-0.0665771 7.96796 -0.0665771 8.39012 0.199761 8.65045C0.46604 8.91076 0.897729 8.91076 1.16398 8.6504L7.49989 2.45514L13.8361 8.65048C14.1024 8.91079 14.5341 8.91079 14.8003 8.65042C14.9334 8.52028 15 8.34967 15 8.17905C15 8.00844 14.9335 7.8378 14.8003 7.70763L7.98194 1.04098C7.85409 0.915914 7.68068 0.845703 7.49986 0.845703C7.31901 0.845703 7.14557 0.915914 7.01769 1.04098Z"
                fill={fill}
            />
        </svg>
    );
};

ChevronIcon.propTypes = {
    fill: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    direction: PropTypes.oneOf(['left', 'right', 'up', 'down'])
};

export default ChevronIcon;
